// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import ExtraRecords from '../../../ExtraInformation/ExtraRecordsDynamicForm/BuilderExtraRecord/Tabs/ExtraRecords';
import { GetFormRecordWithValue } from '@store/ExtraInformation/extraInformationSlice';
import Breadcrumb from '@components/Shared/Breadcrumb';

const ExtraRecordEquipments = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const { Id } = useParams(); // ReferenceId
  const dispatch = useDispatch();
  const [refreshData, setRefreshData] = useState(true);
  //__________________________________________________
  const tableId = '85d9908f-3d3f-45fc-ac73-4b72164a3f65'; // جدول معدات الاسطول

  useEffect(() => {
    if (refreshData) {
      dispatch(
        GetFormRecordWithValue({
          TableId: tableId,
          ReferenceId: Id
        })
      );
      setRefreshData(false);
    }
  }, [refreshData]);
  const { FormRecordWithValueList } = useSelector(state => state.ExtraInformation);

  const reference = JSON.parse(localStorage.getItem('ReferenceName') || '{}');

  //_____________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'Vehicles',
      link: '/FLEET/Equipments'
    },
    {
      name: 'ExtraRecord',
      link: null
    }
  ];

  return (
    <Fragment>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} subtitle={reference?.plateNo} />

        <div className='ms-auto'>
          <Link to='/FLEET/Equipments' replace className='btn me-1 btn-secondary '>
            <i className='fa fa-arrow-left me-2'></i>
            {t('Back')}
          </Link>
        </div>
      </div>

      <ExtraRecords
        setRefreshData={setRefreshData}
        FormRecordWithValueList={FormRecordWithValueList}
        ReferenceId={Id}
      />
    </Fragment>
  );
};

export default ExtraRecordEquipments;
